import React, {useState, useEffect} from "react";
import Modal from 'react-modal';

import { primaryInput } from 'detect-it';

import {ReactComponent as InstruccionsOrdinador} from './assets/instruccions_1_caixa.svg';
import {ReactComponent as InstruccionsTactil} from './assets/instruccions_2_caixa.svg';
import {ReactComponent as InstruccionsTancar} from './assets/instruccions_tancar.svg';

import './Instruccions.css';

const customStyles = {
	content : {
		top                   : '50%',
		left                  : '50%',
		right                 : 'auto',
		bottom                : 'auto',
		marginRight           : '-50%',
		transform             : 'translate(-50%, -50%)',
		border                : 'none',
		boxShadow             : '0 0 15px #a493ed'
	}
};

const Instruccions = (props) => {
	const [modalIsOpen,setIsOpen] = useState(window.sessionStorage.getItem("instructionsHasBeenShown") == null);

	useEffect(() => {
		if (typeof window !== `undefined`) {
			window.sessionStorage.setItem("instructionsHasBeenShown", "true");
		}

		if (! modalIsOpen) {
			props.onClose()
		}
	}, [])

	function closeModal(){
		setIsOpen(false);
		props.onClose()
	}

	Modal.setAppElement('#root');

	return (
		<Modal
			isOpen={modalIsOpen}
			onRequestClose={closeModal}
			style={customStyles}
			contentLabel="Instruccions"
		>

			<button onClick={closeModal} className={"instruccions__tancar-boto"}><InstruccionsTancar className={"instruccions__tancar"}/></button>

			{ primaryInput === 'touch' ? <InstruccionsTactil className={"instruccions__tactil"}/> : <InstruccionsOrdinador className={"instruccions__ordinador"}/> }
		</Modal>
	);
}
export default Instruccions;